import { Link } from 'react-router-dom';

// Import assets
import { ReactComponent as Icon } from 'assets/icons/ic_button_play.svg';

// Import styles
import { ButtonWrapper } from './styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import hooks
import { useDetailsButton } from './hooks';

type Props = {
	uuid: string;
	subtype: string;
	title: string;
};

export const DetailButton = ({ uuid, subtype, title }: Props) => {
	const { linkRedirect, buttonText } = useDetailsButton(uuid, subtype, title);

	return (
		<ButtonWrapper>
			<Button to={linkRedirect} as={Link} icon={<Icon />}>
				{buttonText}
			</Button>
		</ButtonWrapper>
	);
};
